import * as Icons from "lucide-react";
import { ThemeIcon } from "@/components/ThemeIcon";
import { useWordImage } from "@/lib/wordImages";

const KEYWORDS = [
  [/casque/, "HardHat"], [/marteau|massette/, "Hammer"], [/cl[ée]|cl[ée] (à|a) molette/, "Wrench"],
  [/perceuse|perforateur|forer/, "Drill"], [/m[eè]tre|r[eè]gle|niveau|cote|mesur/, "Ruler"],
  [/pinceau|peinture|enduit/, "Paintbrush"], [/rouleau/, "PaintRoller"], [/brique|parpaing|mur|ma[çc]on/, "BrickWall"],
  [/pelle|truelle|tranch/, "Shovel"], [/camion|livraison|benne/, "Truck"], [/chariot|grue|levage|palette/, "Forklift"],
  [/[ée]chafaudage|chantier/, "Construction"], [/c[ôo]ne|balis/, "TrafficCone"], [/[ée]pi|protection|harnais|s[ée]curit/, "ShieldCheck"],
  [/lunette/, "Glasses"], [/chaussure|botte/, "Footprints"], [/gant/, "Hand"], [/[ée]lectri|courant|tension|disjonct/, "Zap"],
  [/prise|fiche/, "Plug"], [/c[âa]ble|fil|gaine/, "Cable"], [/lampe|[ée]clairage|ampoule/, "Lightbulb"],
  [/eau|fuite|tuyau|plomb|robinet|canalisation/, "Droplets"], [/b[ée]ton|mortier|ciment|dosage|consistance|adjuvant|prise/, "Cylinder"],
  [/sable|gravier|granulat/, "Mountain"], [/plan|consigne|liste|bon de/, "ClipboardList"], [/planning|d[ée]lai|heure|horaire/, "Clock"],
  [/[ée]quipe|coll[èe]gue/, "Users"], [/chef|ouvrier|ma[îi]tre/, "User"], [/danger|risque|attention/, "TriangleAlert"],
  [/interdit/, "Ban"], [/bonjour|salut|merci/, "Smile"], [/t[ée]l[ée]phone|appeler/, "Phone"],
  [/coffrage|bois|planche/, "Layers"], [/poids|charge|kilo/, "Weight"], [/d[ée]chet|benne/, "Trash2"],
];

export function resolveIcon(w) {
  if (w.icon && Icons[w.icon]) return Icons[w.icon];
  const text = (w.word || "").toLowerCase();
  const hit = KEYWORDS.find(([re]) => re.test(text));
  return hit ? Icons[hit[1]] : null;
}

export function WordIcon({ word, size = "md", testId }) {
  const Icon = resolveIcon(word);
  const { url, loading } = useWordImage(word);
  const box = size === "lg" ? "w-32 h-32 rounded-2xl" : size === "sm" ? "w-14 h-14 rounded-lg" : "w-20 h-20 rounded-xl";
  const ico = size === "lg" ? "w-12 h-12" : size === "sm" ? "w-6 h-6" : "w-9 h-9";
  return (
    <span
      data-testid={testId}
      data-image-state={url ? "ready" : loading ? "loading" : "icon"}
      className={`shrink-0 grid place-items-center overflow-hidden bg-amber-100 text-amber-800 border-2 border-amber-300 ${box} ${loading ? "animate-pulse" : ""}`}
    >
      {url ? (
        <img src={url} alt={word.word} className="w-full h-full object-cover bg-white" loading="lazy" />
      ) : Icon ? (
        <Icon className={ico} strokeWidth={1.75} />
      ) : (
        <ThemeIcon theme={word.theme} className={ico} />
      )}
    </span>
  );
}
